import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { fetchUsersInitAction, updateSelectedUserAction } from '../../../../actions/usersActions';
import Api from '../../../../services/Api';
import BasePage from '../../BasePage/BasePage';
import Sidebar from '../../../molecules/Sidebar/Sidebar';
import InputControl from '../../../atoms/InputControl/InputControl';
import RolesSelector from '../../../atoms/RolesSelector/RolesSelector';
import Button from '../../../atoms/Button/Button';
import Icon from '../../../atoms/Icon/Icon';
import extractErrors from '../../../../helpers/errors';
import './CreateEditUser.scss';

const CreateEditUser = () => {
  const { selectedUser } = useSelector(state => state.users);
  const [name, setName] = useState(selectedUser ? selectedUser.name : undefined);
  const [email, setEmail] = useState(selectedUser ? selectedUser.email : undefined);
  const [password, setPassword] = useState(undefined);
  const [confirmPassword, setConfirmPassword] = useState(undefined);
  const [roleId, setRoleId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(undefined);
  const dispatch = useDispatch();
  const history = useHistory();
  const saveUser = () => {
    if (!name) {
      setError('Name field is required');
      return;
    }
    if (!email) {
      setError('Email field is required');
      return;
    }
    if (!roleId) {
      setError('Role field is required');
      return;
    }
    if (!selectedUser) {
      if (!password) {
        setError('Password field is required');
        return;
      }
      if (!confirmPassword) {
        setError('Password Confirmation field is required');
        return;
      }
    }
    setIsLoading(true);
    setError(undefined);
    const data = {
      name,
      email,
      role_id: roleId,
    };
    if (!selectedUser) {
      data.password = password;
      data.password_confirmation = password;
    }
    const callback = (response) => {
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchUsersInitAction());
        if (selectedUser) {
          dispatch(updateSelectedUserAction(response.data));
        }
        setTimeout(() => {
          setIsLoading(false);
          history.goBack();
        }, 500);
      } else {
        const errs = extractErrors(response.data);
        setError(errs[0]);
        setIsLoading(false);
      }
    };
    if (selectedUser) {
      Api.patch(`/users/${selectedUser.id}`, data).then(response => callback(response));
    } else {
      Api.post('/users', data).then(response => callback(response));
    }
  };
  return (
    <BasePage>
      <div className="create-component-container">
        <h2 className="col-md-12">{selectedUser ? `Edit ${selectedUser.name}` : 'Create new user'}</h2>
        <br />
        <div className="row">
          <div className="col-md-8">
            <div className="row">
              <div className="col-md-12 mt-4">
                <InputControl label="Name" value={name} type="text" onValueChanged={value => setName(value)} placeholder="Name..." />
              </div>
              <div className="col-md-12 mt-4">
                <InputControl label="Email" value={email} type="text" onValueChanged={value => setEmail(value)} placeholder="Email..." />
              </div>
              <div className="col-md-6 mt-4">
                <InputControl label="Password" value={password} type="password" onValueChanged={value => setPassword(value)} placeholder="Type password here..." />
              </div>
              <div className="col-md-6 mt-4">
                <InputControl label="Confirm Password" value={confirmPassword} type="password" onValueChanged={value => setConfirmPassword(value)} placeholder="Type your password again..." />
              </div>
              <div className="col-md-12 mt-4">
                <label>Role</label>
                <RolesSelector value={roleId} isMulti={false} onChanged={v => setRoleId(v.value)} />
              </div>
              {error && (
                <div className="col-md-12 d-flex justify-content-end mt-5">
                  <span className="text-danger">
                    {error}
                  </span>
                </div>
              )}
              <div className="col-md-12 mt-1 d-flex justify-content-end align-items-center mt-5">
                <Button
                  onInvoked={() => saveUser()}
                  isLoading={isLoading}
                >
                  <span>
                    <Icon icon="save" color="#fff" />
                  </span>
                  <span className="ms-2">
                    {selectedUser ? 'Update' : 'Save'}
                  </span>
                </Button>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <Sidebar />
          </div>
        </div>
      </div>
    </BasePage>
  );
};

CreateEditUser.propTypes = {

};

CreateEditUser.defaultProps = {

};

export default CreateEditUser;
